import React from "react";
import { formatHours, UNASSIGNED } from "./departmentAttendance";

/* Department filter + per-department totals for the Attendance page (owner 11-03).
   totals: [{key, name, employees, clockedIn, seconds}] (departmentAttendance.dailyTotals / recapTotals).
   A department with nobody in it is left out, except the one being filtered on. */
const DepartmentAttendanceBar = ({ departments, value, onChange, totals, view }) => {
  const options = (departments || []).map((d) => ({ id: String(d.departmentid), name: d.name }));
  const shown = (totals || []).filter((t) => t.employees > 0 || t.key === value);
  const hoursLabel = view === "recap" ? "hours" : "recorded";
  return (
    <div className="flex flex-wrap items-center gap-3 my-3" data-testid="dept-attendance-bar">
      <label className="flex items-center gap-2 text-sm text-[#1D2951]">
        <span className="font-medium">Department</span>
        <select
          aria-label="Department"
          className="border border-gray-300 rounded-md px-2 py-1 text-sm bg-white"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">All departments</option>
          {options.map((o) => (
            <option key={o.id} value={o.id}>{o.name}</option>
          ))}
          <option value={UNASSIGNED}>Not set</option>
        </select>
      </label>
      {shown.map((t) => (
        <button
          type="button"
          key={t.key}
          onClick={() => onChange(value === t.key ? "" : t.key)}
          title={`${t.name}: ${t.employees} employees, ${t.clockedIn} ${view === "recap" ? "with hours" : "clocked in"}, ${formatHours(t.seconds)} ${hoursLabel}`}
          className={`rounded-full px-3 py-1 text-xs border ${
            value === t.key ? "bg-[#1D2951] text-white border-[#1D2951]" : "bg-white text-[#1D2951] border-gray-300 hover:bg-gray-100"
          }`}
          data-testid={`dept-total-${t.key}`}
        >
          <span className="font-semibold">{t.name}</span>
          <span className="ml-2">{t.employees} staff</span>
          <span className="ml-2">{t.clockedIn} {view === "recap" ? "worked" : "in"}</span>
          <span className="ml-2">{formatHours(t.seconds)} h</span>
        </button>
      ))}
    </div>
  );
};

export default DepartmentAttendanceBar;
